import React from 'react'
import { Outlet } from 'react-router-dom';

function MainCash() {
  return (
    <div className="w-full h-full">
    <Outlet/>
    </div>
  )
}

export default MainCash;